import type { AddedCableCircuits, LiveAddedCircuits } from "./types";

/**
 * The created runs that are still his to carry — read by the geometry AND by
 * the list, so a row can never exist for a run the geometry has stood down.
 *
 * One rule: **the estimation wins when it catches up.** A later run that
 * publishes `GHV·A5` itself makes his own `GHV·A5` redundant, and two rows for
 * one way is a total nobody can reconcile. Nothing is lost by standing down —
 * every device he put on it is keyed to that same id, so they land on the
 * estimation's circuit without a single override being rewritten.
 */
export const liveAddedCircuits: LiveAddedCircuits = ({
  addedCircuits,
  baseCircuitIds,
}) => {
  const published = new Set(baseCircuitIds);
  const live: AddedCableCircuits = {};
  for (const [circuitId, circuit] of Object.entries(addedCircuits ?? {})) {
    if (published.has(circuitId)) continue;
    live[circuitId] = circuit;
  }
  return live;
};
